<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="box">
      <mat-card-header>
        <mat-card-title>Identification</mat-card-title>
      </mat-card-header>
      <form class="example-form" [formGroup]="loginForm">
        <mat-card-content>
          <mat-form-field class="example-full-width">
            <input matInput formControlName="login" placeholder="Utilisateur">
          </mat-form-field>
  
          <mat-form-field class="example-full-width">
            <input matInput formControlName="password" type="password" placeholder="Mot de passe">
          </mat-form-field>
        </mat-card-content>
        <button mat-stroked-button color="accent" class="btn-block" (click)="authenticate()">Connexion</button>
        <div *ngIf="errormessage" class="loginerror">{{errormessage}}</div>
      </form>
    </mat-card>
  </div>